/* eslint-disable no-restricted-globals */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable multiline-ternary */
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {
	Box,
	Grid,
	IconButton,
	MenuItem,
	Select,
	SelectChangeEvent,
	Slider,
	Stack, Typography
} from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import Hls from 'hls.js';
import { feedActionContext } from '../../../..';
// import ReactHlsPlayer from 'react-hls-player';

interface VideoTypes{
	isPlaying : boolean
	playbackRate : number;
	volume : number;
	isMuted : boolean;
	isVolumeSliderVisible : boolean;
	currentTime : number;
	setIsVideoPlaying: React.Dispatch<React.SetStateAction<boolean>>;
}

const VideoPreview = ({ currentMedia, setIsVideoPlaying, openVideo, from }: {openVideo:any; currentMedia: any; setIsVideoPlaying?: React.Dispatch<React.SetStateAction<boolean>> ;from?:string}) =>
{
	const [ videoState, setVideoState ] = useState<any>({
		isPlaying             : false,
		playbackRate          : 1,
		volume                : 0.5,
		isMuted               : false,
		isVolumeSliderVisible : false,
		currentTime           : 0
	});
	const videoRef = useRef<HTMLVideoElement | null>(null);
	const { isPlaying, playbackRate, volume, isMuted, isVolumeSliderVisible, currentTime } = videoState;
	const isYoutube = currentMedia?.type === 'youtube';
	const { feedAction } = useContext(feedActionContext);

	// Toggle play/pause
	const togglePlayPause = () =>
	{
		if (videoRef.current)
		{
			// videoRef.current.currentTime = 0;
			if (videoRef.current.paused)
			{
				videoRef.current.play();
				setVideoState((prev) => ({ ...prev, isPlaying: true }));
				if (setIsVideoPlaying)
				{
					// videoRef.current.currentTime = 0;
					videoRef.current.play();
					setIsVideoPlaying(true);
				}
			}
			else
			{
				videoRef.current.pause();
				setVideoState((prev) => ({ ...prev, isPlaying: false }));
				if (setIsVideoPlaying)
				{
					setIsVideoPlaying(false);
				}
			}
		}
	};

	// Seek to a specific time in the video
	const handleSeek = (event: Event, newValue: number | number[]) =>
	{
		const seekTime = Array.isArray(newValue) ? newValue[0] : newValue;

		if (videoRef.current)
		{
			videoRef.current.currentTime = seekTime;
			setVideoState((prev) => ({ ...prev, currentTime: seekTime }));
		}
	};

	// Change volume and mute status
	const handleVolumeChange = (event: Event, newValue: number | number[]) =>
	{
		const newVolume = newValue as number;

		setVideoState((prev) => ({ ...prev, volume: newVolume, isMuted: newVolume === 0 }));
		if (videoRef.current)
		{
			videoRef.current.volume = newVolume;
		}
	};

	const toggleMute = () =>
	{
		if (videoRef.current)
		{
			videoRef.current.muted = !isMuted;
			setVideoState((prev) => ({ ...prev, isMuted: !prev?.isMuted }));
		}
	};

	// Handle video playback rate
	const handlePlaybackRateChange = (event: SelectChangeEvent<number>) =>
	{
		const newRate = event.target.value as number; // Ensure value is treated as number

		if (videoRef.current)
		{
			videoRef.current.playbackRate = newRate;
		}
		setVideoState((prev) => ({ ...prev, playbackRate: newRate }));
	};

	const handleVolumeSlider = (status) =>
	{
		setVideoState((prev) => ({ ...prev, isVolumeSliderVisible: status }));
	};

	useEffect(() =>
	{
		if (!open && videoRef.current)
		{
			videoRef.current.pause();
			setVideoState((prev) => ({ ...prev, isPlaying: false }));
			if (setIsVideoPlaying)
			{
				setIsVideoPlaying(false);
			}
		}
	}, [ open ]);

	// Update progress of the video
	const updateProgress = () =>
	{
		if (videoRef.current)
		{
			setVideoState((prev) => ({ ...prev, currentTime: videoRef.current?.currentTime }));
		}
	};

	useEffect(() =>
	{
		const videoElement = videoRef.current;

		if (videoElement)
		{
			videoElement.addEventListener('timeupdate', updateProgress);

			return () => videoElement.removeEventListener('timeupdate', updateProgress);
		}
	}, [ isPlaying ]);

	useEffect(() =>
	{
		const video:any = videoRef.current;

		if (video)
		{
			const shouldMuteAudio = feedAction?.is_full_screen === undefined || feedAction?.is_full_screen === null;

			video.muted = shouldMuteAudio;

			if (feedAction?.is_full_screen === true)
			{
				video.muted = false;
			}

			if (video && Hls.isSupported() && currentMedia?.url?.endsWith('.m3u8'))
			{
				const hls = new Hls({
					maxBufferLength    : 10,
					maxMaxBufferLength : 15,
					autoStartLoad      : true
				});

				hls.loadSource(currentMedia.url);
				hls.attachMedia(video);
				hls.on(Hls.Events.MANIFEST_PARSED, () =>
				{
					console.log('Manifest loaded, preloading video...');
					hls.startLoad(0);
					const checkBuffer = setInterval(() =>
					{
						if (video.buffered.length > 0 && video.buffered.end(0) >= 10)
						{
							clearInterval(checkBuffer);
							if (openVideo)
							{
								video.play();
								setVideoState((prev) => ({ ...prev, isPlaying: true, currentTime: 10 }));
							}
							else
							{
								video.currentTime = 0;
								setVideoState((prev) => ({ ...prev, isPlaying: false, currentTime: 0 }));
							}
						}
					}, 500);
				});
				hls.on(Hls.Events.ERROR, (event, data) =>
				{
					console.error('HLS error:', data);
				});

				return () =>
				{
					hls.destroy();
				};
			}
		}
	}, [ currentMedia?.url, openVideo, feedAction?.is_full_screen ]);

	const PlayIcon = () =>
	{
		return (
			<IconButton
				onClick={togglePlayPause}
				sx={{
					position   : 'absolute',
					top        : 'var(--percent50)',
					left       : 'var(--percent50)',
					transform  : 'translate(-50%, -50%)',
					color      : 'var(--whiteColor)',
					background : 'rgba(0, 0, 0, 0.5)',
					'&:hover'  : {
						background : 'rgba(0, 0, 0, 0.7)'
					}
				}}
			>
				<PlayArrowIcon sx={{ fontSize: '48px' }} />
			</IconButton>
		);
	};

	return (
		<Stack direction={'column'} width={'var(--percent100)'}>
			<Box position='relative' width='var(--percent100)' height='65vh'>
				{isYoutube
					? (
						<ReactPlayer
							key={currentMedia?.key}
							url={currentMedia?.url}
							// playIcon={<PlayIcon/>}
							width='var(--percent100)'
							height='var(--percent100)'
							sx={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }}
							onPlay={() => setIsVideoPlaying && setIsVideoPlaying(true)}
							onPause={() => setIsVideoPlaying && setIsVideoPlaying(false)}
						/>
					)
					: currentMedia?.url?.endsWith('.m3u8')
						? (
							<>
								<video
									ref={videoRef}
									style={{
										width        : '100%',
										height       : '100%',
										objectFit    : 'contain',
										borderRadius : '8px'
									}}
									controls
									autoPlay
								/>
							</>
						)
						: (
							<video
								ref={videoRef}
								src={currentMedia?.url}
								style={{
									width        : 'var(--percent100)',
									maxHeight    : 'var(--percent100)',
									objectFit    : 'contain',
									borderRadius : 'var(--pixel8)'
								// background   : 'rgba(0, 0, 0, 0.5)'
								}}
								onClick={(e) =>
								{
									e.stopPropagation();
									togglePlayPause();
								}}
								onEnded={() =>
								{
									if (videoRef.current)
									{
										videoRef.current.currentTime = 0;
									}
									setVideoState((prev) => ({ ...prev, isPlaying: false }));
									if (setIsVideoPlaying)
									{
										setIsVideoPlaying(false);
									}
								}}
								controls={false}
							/>
						)}
				{!isPlaying && !isYoutube && !currentMedia?.url?.endsWith('.m3u8') && (
					<PlayIcon/>
				)}
			</Box>
			{!isYoutube && !currentMedia?.url?.endsWith('.m3u8') && <Grid container alignItems='center' justifyContent='space-between' sx={{ width: { xs: '88%', md: 'var(--percent100)' } }}>
				<Grid item xs={2} sm={1} display={'flex'} alignItems={'center'} justifyContent={'start'}>
					<IconButton onClick={togglePlayPause} sx={{ color: 'var(--whiteColor)' }}>
						{isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
					</IconButton>
				</Grid>
				<Grid item xs={3} sm={5} md={5} display={'flex'} alignItems={'center'}>
					<Slider
						value={currentTime}
						max={videoRef.current?.duration || 0}
						onChange={handleSeek}
						sx={{ color: 'var(--whiteColor)' }}
					/>
				</Grid>
				<Grid item xs={3} sm={2} display={'flex'} alignItems={'center'} ml={1}>
					<Typography
						color='var(--whiteColor)'
						sx={{
							fontSize : {
								xs : 'var(--pixel8)',
								sm : 'var(--pixel14)',
								md : 'var(--pixel16)'
							}
						}}
					>
						{`${Math.floor(currentTime / 60)}:${String(Math.floor(currentTime % 60)).padStart(2, '0')} / ${Math.floor((videoRef.current?.duration || 0) / 60)}:${String(Math.floor((videoRef.current?.duration || 0) % 60)).padStart(2, '0')}`}
					</Typography>
				</Grid>
				<Grid item xs={1} display={'flex'} alignItems={'center'}>
					<Box
						sx={{ position: 'relative' }}
						onMouseEnter={() => handleVolumeSlider(true)}
						onMouseLeave={() => handleVolumeSlider(false)}
					>
						<IconButton onClick={toggleMute} sx={{ color: 'var(--whiteColor)' }}>
							{isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
						</IconButton>
						{isVolumeSliderVisible && (
							<Box
								sx={{
									position  : 'absolute',
									bottom    : 'var(--percent100)',
									left      : 'var(--percent50)',
									transform : 'translateX(-50%)',
									width     : 30
								}}
							>
								<Slider
									orientation='vertical'
									value={isMuted ? 0 : volume}
									onChange={handleVolumeChange}
									aria-labelledby='volume-slider'
									min={0}
									max={1}
									step={0.05}
									sx={{
										color     : 'var(--whiteColor)',
										height    : 100,
										marginTop : 'var(--pixel10)'
									}}
								/>
							</Box>
						)}
					</Box>
				</Grid>
				<Grid item xs={1} display={'flex'} alignItems={'center'}>
					<Select
						value={playbackRate}
						onChange={handlePlaybackRateChange}
						sx={{
							color                              : 'var(--whiteColor)',
							border                             : 'none',
							'.MuiOutlinedInput-notchedOutline' : {
								border : 'none'
							},
							'& .MuiSelect-icon' : {
								color : 'var(--whiteColor)'
							},
							'&:hover .MuiOutlinedInput-notchedOutline' : {
								border : 'none'
							},
							'&.Mui-focused .MuiOutlinedInput-notchedOutline' : {
								border : 'none'
							}
						}}
					>
						<MenuItem value={0.5}>0.5x</MenuItem>
						<MenuItem value={1}>1x</MenuItem>
						<MenuItem value={1.5}>1.5x</MenuItem>
						<MenuItem value={2}>2x</MenuItem>
					</Select>
				</Grid>
			</Grid>}
		</Stack>
	);
};

export default VideoPreview;